import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.TriggerActionButton,
  title: 'Action Trigger',
  category: ComponentCategory.General,
};
